@if (item.producedDocuments.length > 0) {
  <div>
    <div class="declaration-block my-4">
      <h2>Import documents</h2>
    </div>
  </div>
}

@for (document of item.producedDocuments; track document) {
  <div class="my-2">
    <app-collapse [collapse]="placementTemplate" [showOnLoad]="!document.id"
                  [deleteHandle]="context.cargoImportModel.isEditor() && removeItem(document)"
                  [validationModel]="document">
      <div class="row pe-3 g-0 align-items-center">
        <div class="col-auto mx-2 p-2">
          <span class="fa fa-fw fa-file-alt text-dark"></span>
        </div>
        <div class="col text-dark">
          <span class="d-inline-block align-top text-truncate">{{ document.id || 'New document' }}</span>
        </div>
      </div>
    </app-collapse>
    <ng-template #placementTemplate>
      <div class="collapse">
        <div class="mx-3 pt-3">
          <div class="row">
            <div class="col-md">
              <app-form-group label="Type">
                <app-select [(ngModel)]="document.type" placeholder="– Select type –"
                            [formatter]="documentTypeFormatter"
                            required [options]="refData.goodsDocumentOptions">
                </app-select>
              </app-form-group>
              <app-form-group label="Document id">
                <input required [(ngModel)]="document.id" class="form-control">
              </app-form-group>
            </div>
            <div class="col-md">
              <app-form-group label="Description">
                <textarea [(ngModel)]="document.description" class="form-control"
                          style="min-height: 5.75rem;"></textarea>
              </app-form-group>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
}

@if (context.cargoImportModel.isEditor()) {
  <div class="row align-items-center">
    <div class="col-auto ms-auto">
      <ul class="nav">
        <li class="nav-item">
          <a href="#" class="nav-link p-0" (click)="$event.preventDefault(); addItem()">
            <span class="pe-2 fa fa-plus-circle"></span>Add import document</a>
        </li>
      </ul>
    </div>
  </div>
}
